import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { groupItemsByTypes } from '@/logic/main/utils';
import { SEARCH_RESULT_CATEGORY_ID } from '@/model/constants';
import { getLocale } from '@/utils';
import { SubheaderItemTitleMapper } from '@/utils/subheaderItemTitleMapper';

export const setSearchResultsContent = async (context: LogicContext) => {
  const { searchItems, currentType } = context.search;
  const phrase = context.search.searchPhrase;
  const deviceType = context.deviceInfo.deviceType;
  const subheaderItems: Array<{
    title: string;
    type: string;
    state: 'active' | 'inactive';
  }> = [];
  const locale = getLocale(config);
  const currency = context.user?.currency || config.default_currency;

  const groupedItems = groupItemsByTypes(searchItems);
  const [, searchCategoryComponent] =
    context.controllersData.search?.components.find(
      ([, comp]) => comp.type === 'SearchCategory'
    ) || [];
  const subheaderItemTitleMapper = new SubheaderItemTitleMapper(
    searchCategoryComponent?.properties?.staticTexts?.slots
  );
  let index = 0;
  for (let [type, items] of Object.entries(groupedItems)) {
    if (items.length) {
      const title = `${subheaderItemTitleMapper.mapType(type)} (${
        items.length
      })`;
      subheaderItems[index] = {
        title: title,
        type: type,
        state: currentType === type ? 'active' : 'inactive',
      };
      index++;
    }
  }

  const searchResultCategory = {
    id: SEARCH_RESULT_CATEGORY_ID,
    title: `Search Results`,
    games: groupedItems[currentType],
  };

  const searchCategoryVisible = Boolean(searchItems.length > 0);

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchNoResults.properties`,
          value: {
            visible: !searchCategoryVisible,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResults.properties`,
          value: {
            visible: searchCategoryVisible,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResult.properties`,
          value: {
            category: searchResultCategory,
            locale,
            currency,
            deviceType,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchHeader.properties`,
          value: {
            subheaderItems,
            searchItems: groupedItems,
            searchedPhrase: phrase,
          },
        },
      },
    ],
  };
};
